import { EXPECTED_MEDIA_PLAYBACK_REJECTION_MESSAGES } from "./constants";

const getErrorMessage = (error: unknown): string => {
  if (typeof error === "string") {
    return error;
  }

  const message = (error as { message?: unknown } | null)?.message;
  return typeof message === "string" ? message : "";
};

export const isExpectedMediaPlaybackRejection = (error: unknown): boolean => {
  const name = (error as { name?: unknown } | null)?.name;
  if (name === "NotAllowedError") {
    return true;
  }

  const message = getErrorMessage(error).toLowerCase();

  return (
    (message.includes(EXPECTED_MEDIA_PLAYBACK_REJECTION_MESSAGES.playFailed) &&
      message.includes(EXPECTED_MEDIA_PLAYBACK_REJECTION_MESSAGES.missingUserInteraction)) ||
    message.includes(EXPECTED_MEDIA_PLAYBACK_REJECTION_MESSAGES.interruptedByPause) ||
    message.includes(EXPECTED_MEDIA_PLAYBACK_REJECTION_MESSAGES.mediaFetchAborted)
  );
};
